import React, { useEffect } from 'react';

import { useFeatureAppConfig } from './services/use-feature-app-config';
import RecallsApp from './page/recalls-app';
import {
  Container,
  ContainerPadding,
  Breakpoints,
} from '@vw-marketing/us-components';
import { useTrackingManager } from './services/use-tracking-manager';

export interface AppProps {
  readonly baseUrl?: string;
}

export function App({ baseUrl }: AppProps): JSX.Element | null {
  const { mode } = useFeatureAppConfig();
  mode && mode;
  console.log(baseUrl);

  const trackingManager = useTrackingManager();

  useEffect(() => {
    trackingManager.trackRecallsGlobalEvent(
      'VWBasic_VINForm_Load',
      {
        FormStart: true,
        FormType: 'otherform',
        FormVersion: '1',
        FormName: 'Recall Request',
      },
      undefined,
    );
  }, []);
  return (
    <Container
      padding={{
        right: {
          [Breakpoints.default]: ContainerPadding.grid002,
          [Breakpoints.b560]: ContainerPadding.grid006,
          [Breakpoints.b1600]: ContainerPadding.grid007,
        },
        left: {
          [Breakpoints.default]: ContainerPadding.grid002,
          [Breakpoints.b560]: ContainerPadding.grid006,
          [Breakpoints.b1600]: ContainerPadding.grid007,
        },
      }}
      stretchContent
    >
      <RecallsApp />
    </Container>
  );
}
